module.exports = __webpack_public_path__ + "static/media/leeskost-onder-de-vlinderboom-min.896581b0.png";